import {
  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__SUCCESS:
    case ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__REQUEST:
      return null;

    case ACTION_EDIT_SITE_FOOTER_LINK_CATEGORY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
